import { QueryClient } from '@tanstack/react-query';

/**
 * NOTE - prefer using `useQueryClient` hook instead of accessing this QueryClient instance directly
 * Shared React Query client instance used throughout the application.
 * Exported separately to avoid circular dependency issues when importing into sagas.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: { refetchOnWindowFocus: false, retry: false, staleTime: 500 },
	},
});

export default queryClient;
